import { useMemberProfiles } from 'views/MemberProfile/useMemberProfiles'

export const useMemberProfileVersion = () => {
  const {
    memberMemberProfiles,
    memberMemberProfilesModStatus,
    memberMemberProfilesModErrors,
  } = useMemberProfiles()

  return {
    memberMemberProfiles,
    memberMemberProfilesModStatus,
    memberMemberProfilesModErrors,
  }
}
